/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
import Moment from 'moment-jalali';
import axios from "axios";
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import Constants from "./_framework/Constants";
// import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
//
// Vue.component('font-awesome-icon', FontAwesomeIcon);
// Vue.component('font-awesome-layers', FontAwesomeLayers);
// Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.config.productionTip = false;

Vue.use(NowUiKit);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

Vue.mixin({
    data() {
        return {
            // userRole: 'user'
        }
    },
    mounted() {
        // $(window).on("scroll", () => {
        //     if ($(window).scrollTop() > 62) {
        //         if ($(window).width() > 991) {
        //             $(".navbar").addClass("navbar-color").addClass("shadow");
        //         }
        //         if (!$(".sidebar").hasClass("open") && $(window).width() < 991) {
        //             $(".navbar").addClass("navbar-color").addClass("shadow");
        //         }
        //     } else {
        //         $(".navbar").removeClass("navbar-color").removeClass("shadow");
        //     }
        // });
        // this.userRole = localStorage.getItem("role");
    },
    methods: {
        // onDropDownFocused(val) {
        //     $(val).find(".dropdown-toggle").addClass("focused");
        // },
        // onDropDownBlurred(val) {
        //     $(val).find(".dropdown-toggle").removeClass("focused");
        // },
        // validateImage(img) {
        //     if (img === undefined || img === null || img === "" ||
        //         img.endsWith("default.jpg") || img.endsWith("default.png") ||
        //         img.endsWith("-.jpg") || img === Constants.BASE_URL + "/") {
        //         // placeholder
        //         return require("../public/img/placeholder.jpg");
        //     } else {
        //         return img;
        //     }
        // },
        validateImageUrl(img) {
            if (img !== undefined) {
                return Constants.BASE_URL + "/" + img;
            }
        },
        // validateProfileImage(img) {
        //     if (img === undefined || img === null || img === "" ||
        //         img.endsWith("default.jpg") || img.endsWith("default.png") ||
        //         img.endsWith("-.jpg") || img === Constants.BASE_URL + "/") {
        //         // placeholder
        //         return require("../public/img/user-placeholder.png");
        //     } else {
        //         return img;
        //     }
        // },
        // validateProfilePlaceholder(img) {
        //     // let final = img.substr(img.lastIndexOf('/') + 1);
        //     // let file = final.split('.');
        //     // return "/img/" + file[0] + '.' + file[2];
        // },
        // validatePrice(price) {
        //     const formatter = new Intl.NumberFormat('fa-IR', {
        //         style: 'decimal',
        //         minimumFractionDigits: 0
        //     });
        //     return formatter.format(price) + " ریال";
        // },
        gregorianToJalali(val) {
            let date = Moment(val, "YYYY-MM-DD HH:mm");
            return date.format("jYYYY/jMM/jDD HH:mm");
        },
        jalaliToGregorian(val) {
            let date = Moment(val, "jYYYY/jMM/jDD HH:mm");
            return date.format("YYYY/MM/DD HH:mm");
        },
        gregorianToJalaliBeautified(val, dateTime = false) {
            if (val !== undefined) {
                if (dateTime) {
                    let date = Moment(val, "YYYY/MM/DD HH:mm");
                    return date.format("jDD jMMMM jYYYY HH:mm");
                } else {
                    let date = Moment(val, "YYYY/MM/DD");
                    return date.format("jDD jMMMM jYYYY");
                }
            } else {
                return val;
            }
        },
        unbind(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        removeBase64Comma(base64) {
            return base64.split(",").pop();
        },
        raiseError() {
            this.$noty.error("خطا! لطفا با مدیر سیستم تماس بگیرید");
        },
        redirectTo(name) {
            if (localStorage.getItem("token") === null) {
                this.$router.push({name: 'login'});
            } else {
                this.$router.push({name: `${name}`});
            }
        },
        isEmpty(obj) {
            return obj === undefined || obj === null === obj === "";
        }
    },
    // beforeRouteLeave(to, from, next) {
    //     if ($(window).width() < 991) {
    //         $(".sidebar").removeClass("open");
    //         $(".wrapper").addClass("wide");
    //     }
    //     next();
    // }
});

Moment.loadPersian({dialect: 'persian-modern'});


Vue.config.productionTip = false;
axios.defaults.baseURL = window.BASE_URL + '/api';
axios.defaults.headers.common['authorization'] = 'bearer' + localStorage.getItem('token');

